/**
 * Adjust Web SDK 初始化模块
 * 文档: https://dev.adjust.com/zh/sdk/web
 */

import Adjust from '@adjustcom/adjust-web-sdk'
import { isProduction } from '@/utils'

/**
 * 初始化 Adjust SDK
 */
export function initAdjust() {
  Adjust.initSdk({
    appToken: import.meta.env.VITE_ADJUST_APP_TOKEN,
    environment: !isProduction ? 'sandbox' : 'production',
    logLevel: !isProduction ? 'verbose' : 'none',
  })
}

export { Adjust }
